import React from 'react';
import AppRoutes from './AppRoutes';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App" >
      <AppRoutes/>
    </div>
  );
}

export default App;
